module.exports = __webpack_public_path__ + "img/giaCertificate@2x.85edb85.jpg";